import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

import { useUtils } from '@core/libs/i18n'
                
                

export default function useTypesList(root) {
  const { t } = useUtils()
  const refTypeListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'name', sortable: false, label: t('Name')},
    // { key: 'description', sortable: false, label: 'Description'},
    { key: 'category', sortable: true, label: t('Category')},
    { key: 'actions',label:t('actions') },
  ]

  const perPage = ref(10)
  const totalTypes = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const categoryFilter = ref(null)
  const categoriesOptions = ref([])
  const typesCategoriesFilter = ref([])
  const requestStatus = ref(false)

  const dataMeta = computed(() => {

    const localItemsCount = refTypeListTable.value ? refTypeListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTypes.value,
    }
  })

  const refetchData = () => {
    refTypeListTable.value.refresh()
  }

  const filter = ref({})

  watch([currentPage, perPage, searchQuery, categoryFilter ], () => {
    filter.value = {
      ...(categoryFilter.value && {category: categoryFilter.value}),
      ...(searchQuery.value && {q: searchQuery.value})
    }

    refetchData()

  })

  const fetchTypes = (ctx, callback) => {

    requestStatus.value = true

    store
      .dispatch('app-type/fetchTypes', {
        length: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        ...filter.value
        // sortDesc: isSortDirDesc.value,
      })
      .then(response => {
        requestStatus.value = false
        const { data } = response.data.types
        const { total } = response.data.types.meta

        callback(data)
        totalTypes.value = total
      })
      .catch(e => {
        requestStatus.value = false
        console.log(e)
      })
  }


  const removeType = (id) => {

    root.$swal({
      title: root.$i18n.t("Are You Sure"),
      text: root.$i18n.t("Do you want to delete this type?"),
      showCancelButton: true,
      confirmButtonText: root.$i18n.t('Delete'),
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
      },
      buttonsStyling: false,
    }).then(result => {
      if (result.value) {
        requestStatus.value = true
        store.dispatch('app-type/deleteType', id)
          .then(_ => refetchData())
          .catch(reason => console.log(reason))
      }
    })
  }


  // store.dispatch('app-type/getCategories', { type: 'both'}).then(response =>
  //   categoriesOptions.value = response.data.data)
  //   .catch(reason => console.log(reason))


    store.dispatch('app-type/getCategories', { type: 'all'}).then(response =>
      categoriesOptions.value = response.data.data)
      .catch(reason => console.log(reason))




  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*


  return {

    fetchTypes,
    tableColumns,
    categoriesOptions,
    typesCategoriesFilter,
    perPage,
    currentPage,
    totalTypes,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refTypeListTable,
    removeType,
    categoryFilter,
    requestStatus,
    refetchData,

  }
}
